import { styled } from '@mui/material';

export const PageWrapper = styled('div')(({ theme }) => ({
    marginLeft: 40,
    marginRight: 40,
    height: '100vh',
    display: 'grid',
    gridTemplateRows: 'auto 1fr auto',
    gridTemplateColumns: 'minmax(max-content, 1200px)',
    justifyContent: 'center',
    [theme.breakpoints.down('mobile')]: {
        gridTemplateColumns: '1fr',
    },
}));
export const Paper = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('mobile')]: {
        boxShadow: '0 0 4px rgba(48, 51, 52, 0.2)',
    },
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
}));
export const Logo = styled('img')(({ theme }) => ({
    width: 120,
    paddingTop: 24,
    paddingBottom: 24,
    [theme.breakpoints.down('mobile')]: {
        margin: '0 auto',
    },
}));
export const Footer = styled('footer')(({ theme }) => ({
    marginTop: 32,
    marginBottom: 16,
    [theme.breakpoints.down('mobile')]: {
        marginLeft: 'auto',
        marginRight: 'auto',
    },
}));
